import { Package, Session } from "@/api/dtos";
import { createContext } from "react";

export interface IPackageContext {
    packages?: Package[];
    packagesLoading?: boolean;
    package?: Package;
    additionalSessions?: Session[];
    additionalSessionsLoading?: boolean;
    isEarlyBird?: boolean;
}

const PackageContext = createContext<IPackageContext>({})

export default PackageContext;